export enum HttpStatusCode {
    Unauthorized = 401,
    NotFound = 404
}